// extracted by mini-css-extract-plugin
export default {"wrapper":"dSRYliC7","mobile":"mobile","signed":"Ji6qw4JD","title":"tWLHmpUb","text":"wk9wlpaK","button":"gKt3t4D2","additionalTopics":"CLTaW48A","additionalTopicsTitle":"tU0ONCVt"};